<template>
  <div>    
    <WelcomeMessage />
    <NavMenu />
    <router-view />
  </div>
</template>
  
  <script>
  import { RouterView } from "vue-router";
  import NavMenu from "../../layout/CashFlow/NavMenu.vue";
  import WelcomeMessage from "../../components/WelcomeMessage.vue";
  
  export default {
    components: { NavMenu, WelcomeMessage },
    data() {
        return {
            cashFlow: 1000,
        };
    },
    methods: {
        increaseCashFlow() {
            this.cashFlow += 100;
        },
    }
};
  </script>
<style scoped>
</style>